import React from 'react';

const MailIcon = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33464 13.6668C1.8763 13.6668 1.48394 13.5036 1.15755 13.1772C0.831163 12.8509 0.667969 12.4585 0.667969 12.0002V2.00016C0.667969 1.54183 0.831163 1.14947 1.15755 0.823079C1.48394 0.496691 1.8763 0.333496 2.33464 0.333496H15.668C16.1263 0.333496 16.5187 0.496691 16.8451 0.823079C17.1714 1.14947 17.3346 1.54183 17.3346 2.00016V12.0002C17.3346 12.4585 17.1714 12.8509 16.8451 13.1772C16.5187 13.5036 16.1263 13.6668 15.668 13.6668H2.33464ZM9.0013 7.68766C9.07075 7.68766 9.14366 7.67725 9.22005 7.65641C9.29644 7.63558 9.36936 7.60433 9.4388 7.56266L15.3346 3.87516C15.4457 3.80572 15.5291 3.71891 15.5846 3.61475C15.6402 3.51058 15.668 3.396 15.668 3.271C15.668 2.99322 15.5499 2.78488 15.3138 2.646C15.0777 2.50711 14.8346 2.51405 14.5846 2.66683L9.0013 6.16683L3.41797 2.66683C3.16797 2.51405 2.92491 2.51058 2.6888 2.65641C2.45269 2.80225 2.33464 3.00711 2.33464 3.271C2.33464 3.40988 2.36241 3.53141 2.41797 3.63558C2.47352 3.73975 2.55686 3.81961 2.66797 3.87516L8.5638 7.56266C8.63325 7.60433 8.70616 7.63558 8.78255 7.65641C8.85894 7.67725 8.93186 7.68766 9.0013 7.68766Z"
        fill="#3853C4"
      />
    </svg>
  );
};

export default MailIcon;
